import React from 'react';
import { Droplets, Stethoscope, Home as HomeIcon } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from './ui/dialog';

const iconMap = {
  Droplets,
  Stethoscope,
  Home: HomeIcon
};

const CampaignDetailModal = ({ campaign, open, onOpenChange }) => {
  if (!campaign) return null;
  const Icon = iconMap[campaign.icon] || HomeIcon;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto bg-white p-0">
        <div className="relative">
          {/* Header band */}
          <div className="bg-gradient-to-br from-forest-green to-forest-green/80 text-white px-6 md:px-8 pt-8 pb-6">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-warm-amber flex items-center justify-center flex-shrink-0 shadow-lg">
                <Icon className="w-7 h-7 md:w-8 md:h-8 text-white" />
              </div>
              <div>
                <span className="text-3xl mr-2" aria-hidden="true">{campaign.emoji}</span>
                <DialogHeader className="space-y-1 text-left">
                  <DialogTitle className="text-2xl md:text-3xl font-heading font-bold text-white">
                    {campaign.title}
                  </DialogTitle>
                  <DialogDescription className="text-sand-beige italic text-base md:text-lg">
                    {campaign.tagline}
                  </DialogDescription>
                </DialogHeader>
              </div>
            </div>
          </div>

          {/* Body */}
          <div className="px-6 md:px-8 py-6 space-y-4">
            {campaign.paragraphs.map((para, idx) => (
              <p
                key={idx}
                className="text-gray-700 text-base leading-relaxed"
              >
                {para}
              </p>
            ))}

            {campaign.subheading && (
              <div className="pt-2">
                <h4 className="text-lg md:text-xl font-bold font-heading text-forest-green mb-3">
                  {campaign.subheading}
                </h4>
                <ul className="space-y-2">
                  {campaign.impact.map((item, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <span className="mt-2 inline-block w-1.5 h-1.5 rounded-full bg-warm-amber flex-shrink-0" />
                      <span className="text-gray-700 text-base">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {campaign.closing && (
              <p className="pt-2 text-warm-amber font-semibold italic text-base md:text-lg">
                {campaign.closing}
              </p>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CampaignDetailModal;